




















import { Component, Prop, Vue } from 'vue-property-decorator';
import { HeaderStyle, NavigationLink } from 'types/header';
import { marketingLinks, marketingLinksAbTestTrackRecord } from '../links';
import DesktopNavTemplate from '@components/header/navigation/desktop/desktop-nav-template.vue';
import { getAbTestGroup } from '@api/ab-test';
import NavigationLinkDesktop from '@components/header/navigation/desktop/navigation-link-desktop.vue';

@Component({
	components: {
		DesktopNavTemplate,
		NavigationLinkDesktop
	}
})
export default class DesktopNav extends Vue {
	@Prop()
	private styles!: HeaderStyle;

	navMarketingLinks: Array<NavigationLink> = marketingLinks;

	get loginClasses(): string {
		const toReturn = ['button mr-50'];
		if (this.styles.buttonClassLogin) {
			toReturn.push(`${this.styles.buttonClassLogin}`);
		}

		return toReturn.join(' ');
	}

	get getStartedClasses(): string {
		const toReturn = ['button'];

		if (this.styles.buttonClassGetStarted) {
			toReturn.push(`${this.styles.buttonClassGetStarted}`);
		}

		return toReturn.join(' ');
	}

	appBasePath = process.env.VUE_APP_BASE_PATH;

	public async created(): Promise<void> {
		const abTestGroup = (await getAbTestGroup('2022-01-06_track_record_nav')) || '';
		this.navMarketingLinks = abTestGroup === 'TOP_NAV' ? marketingLinksAbTestTrackRecord : marketingLinks;
	}
}
